import TitleValue from "../../../models/dtos/base/TitleValue";
import { StudentInitialRegistrationDTO } from "../../../models/dtos/identity/StudentInitialRegistrationDTO";
import { StudentInitialRegistrationView } from "../../../models/views/identity/StudentInitialRegistrationView";

export default interface RegisterState {
    entity: StudentInitialRegistrationDTO;
    userInformation: StudentInitialRegistrationView;
    studentFields: TitleValue<number>[];
    studentBases: TitleValue<number>[];
    birthDateValue?: {
        year: number;
        month: number;
        day: number;
    };
    step: RegisterSteps;
    showNavigator: boolean;
}
export interface RegisterPageProps {
    reffererId: string | null;
}

export enum RegisterSteps {
    personalInformation,
    gradeInformation,
    systemInformation,
    otpCode
}